module.exports = __webpack_public_path__ + "97cab5ba02215694f71ccb5499b9bd1a.pdf";